import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const DirectionArrow: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 37 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.69244 8.31382L30.8623 8.30051L25.4139 2.84231C25.0924 2.52951 24.9108 2.09996 24.9108 1.65137C24.9234 0.171147 26.7184 -0.555696 27.7567 0.49937L36.0706 8.80348C36.7214 9.4527 36.7214 10.5069 36.0706 11.1562L27.7567 19.4603C26.1862 21.0866 23.7789 18.6658 25.4139 17.1044L30.8947 11.6234L1.69244 11.6368C0.755837 11.6534 -0.00933332 10.8925 8.60438e-05 9.95582C0.00636562 9.03307 0.769841 8.29582 1.69244 8.31382Z"
        fill="currentColor"
      />
    </svg>
  )
})

DirectionArrow.displayName = 'DirectionArrow'
